export const trainerTexts = {
    pl: {
        header_primary: 'Most na Rzece Sava',
        header_secondary: 'Panel Trenera',
        timer: 'timer',
        init_timer: 'Uruchom timer',
        bridge_state: 'Aktualny stan mostu',
        vote: 'Głosowanie',
        start_vote: 'Uruchom głosowanie',
        break_vote: ' Wróć do dyskusji',
        end_vote: 'Zakończ głosowanie / Wyświetl graczom wyniki',
        result: 'Zobacz wyniki',
        solution: 'Optymalne rozwiązanie',
        sheep: 'OwcoDawanie',
        sheep_end: 'Zakończ OwcoDawanie',
        close_game: 'Zakończ grę',
        social: 'Znajdź nas',
        adress: 'Limanowskiego 31/15',
        mail: 'biuro@mindlab.pl',
        tel: '12 292 75 83',
        game: 'Gra: ',
        game_state: 'Status gry: ',
        active: 'Aktywna',
        end: 'Zakończona',
        inactive: 'Nieaktywna',
        players: 'Graczy: ',
        variants: ' Wariant:',
        login: 'Jesteś zalogowany jako:',
        games: 'Twoje gry:',
        closed: 'Pokaz zakończone gry',
        running: 'Pokaż trwające gry',
        other: 'Pokaż przygotowane gry',
        license: 'Pozostało licencji:',
        new_game: 'Stwórz nową grę',
        refresh: 'Odśwież',
        mayor: 'Sołtys',
        brother: 'Brat Sołtysa',
        handyman: 'Złota Rączka',
        captain: 'Dowódca Straży Wiejskiej',
        sorcerer: 'Guślarz',
        chairwoman: 'Przewodnicząca Koła Gospodyń Wiejskich',
        engineer: 'Inżynier-Konsultant',
        attention: 'Uwaga',
        attention__hover: 'Kliknij aby zakończyć',
        engineersecond: 'Inżynierka-Konsultantka',
        attention_sidebar: 'Uczestnik wymaga Twojej uwagi!',
        log_as: 'Jesteś zalogowany/a jako:',
        your_games: 'Twoje gry',
        your_games_end: 'Pokaż zakończone gry',
        your_games_running: 'Pokaż trwające gry',
        your_games_prepared: 'Pokaż przygotowane gry',
        languages: 'Możesz przeglądać tę stronę w następujących językach',
        languages_polish: 'Polski',
        languages_english: 'English',
        languages_update: 'Zmień',
        licenses_left: 'Pozostało licencji: ',
        login_prompt: 'Zaloguj się na swoje konto',
        login_confirm: 'Zaloguj się',
        forgot_pass: 'Nie pamiętasz hasła?',
        click_here: 'Kliknij tutaj!',
        send: 'Wyślij',
        create_game: 'Stwórz nową grę',
        refresh: 'Odśwież',
        logout: 'Wyloguj >',
        enter_new_pass: 'Podaj swoje nowe hasło',
        game_status: 'Status gry:',
        game: 'Gra',
        lang: 'język',
        game_active: 'Aktywna',
        game_end: 'Zakończona',
        game_inactive: 'Nieaktywna',
        links_set: 'Zestaw linków',
        trainer: 'Trener',
        copy: 'Skopiuj!',
        delete_game: 'Usuń grę!',
        add_player: 'Gracz +',
        subtr_player: 'Gracz - ',
        waiting_room: 'Uruchom poczekalnię',
        game_details: 'Szczegóły rozgrywki',
        council_members: 'Lista członków Rady',
        engineers: 'Lista inzynierów',
        copy_link: 'Skopiuj link!',
        empty_waiting_info:
            ' albo jeszcze nikogo nie ma, albo zmieniłeś liczbę graczy, wtedy poproś graczy o refresz przeglądarki.',
        activate_game: 'Uruchom grę!',
        you_sure: 'Na pewno?',
        cant_change_players: 'Nie będzie można zmienić już liczby graczy',
        cancel_create: 'Nie, jednak nie',
        confirm_create: 'Tak, grajmy już!',
        show: 'Pokaż',
        hide: 'Ukryj',
        lang_not_set: 'Nie wybrano',
    },
    eng: {
        header_primary: 'Sava River bridge',
        header_secondary: "Trainer's Panel",
        timer: 'Timer',
        init_timer: 'Start timer',
        bridge_state: 'Current bridge state',
        vote: 'Voting',
        start_vote: 'Start the voting',
        break_vote: 'Back to discussion',
        end_vote: 'Close the voting / Display results',
        result: 'See the results',
        solution: 'Best solution',
        sheep: 'Sheeping',
        sheep_end: 'Close Sheeping',
        close_game: 'Close game',
        social: 'Znajdź nas',
        adress: 'Limanowskiego 31/15',
        mail: 'biuro@mindlab.pl',
        tel: '12 292 75 83',
        game: 'Game: ',
        game_state: 'Game state: ',
        active: 'Active',
        end: 'Closec',
        inactive: 'Not activated',
        players: 'Players: ',
        variants: ' Version:',
        login: 'Logged in as:',
        games: 'Your games:',
        closed: 'Show closed games',
        running: 'Show active games',
        other: 'Show prepared games',
        license: 'Licenses left:',
        new_game: 'Create game',
        mayor: 'Village Chief',
        brother: "Chief's brother",
        handyman: 'Handyman',
        captain: 'Captain of the village guard',
        sorcerer: 'Soothsayer',
        chairwoman: "Chairwoman of the Village Women's Union",
        engineer: 'Engineer',
        attention: 'Attention',
        attention__hover: 'Click to close',
        engineersecond: 'Second engineer',
        attention_sidebar: 'User needs your attention!',
        log_as: 'Logged in as:',
        your_games: 'Your games',
        your_games_end: 'Show closed games',
        your_games_running: 'Show active games',
        your_games_prepared: 'Show prepared games',
        languages: 'You can browse this page using following langueages',
        languages_polish: 'Polski',
        languages_english: 'English',
        languages_update: 'Change',
        licenses_left: 'Licences left: ',
        login_prompt: 'Login',
        login_confirm: 'Login',
        forgot_pass: 'Forgot password?',
        click_here: 'Click here!',
        send: 'Send!',
        create_game: 'Create game',
        refresh: 'Refresh',
        logout: 'Logout >',
        enter_new_pass: 'New password',
        game_status: 'Game state:',
        game: 'Game',
        lang: 'language',
        game_active: 'Active',
        game_end: 'Closed',
        game_inactive: 'Not activated',
        links_set: 'Linsk set',
        trainer: 'Trainer',
        copy: 'Copy',
        delete_game: 'Delete game!',
        add_player: 'Player +',
        subtr_player: 'Player - ',
        waiting_room: 'Start waiting room',
        game_details: 'Game details',
        council_members: 'Council members',
        engineers: 'Engineers',
        copy_link: 'Copy link!',
        empty_waiting_info:
            ' either nobody is here yet, or you have changed players count - ask players to refresh their browsers',
        activate_game: 'Game start!',
        you_sure: 'Are you sure?',
        cant_change_players: 'Players count change will be no longer possible',
        cancel_create: 'No, changed my mind',
        confirm_create: 'Yeah, lets play already',
        show: 'Show',
        hide: 'Hide',
        lang_not_set: 'Not set yet',
    },
    variants: {
        pl: [
            '4 członków rady, konsultant i list od Sołtysa',
            '5 członków rady, konsultant',
            '5 członków rady i 2 konsultantów',
            '6 członków rady, 2 konsultantów',
        ],
        eng: [
            "4 council members, engineer and Chief's letter",
            '5 council members, engineer',
            '5 council members, 2 engineers',
            '6 council members, 2 engineers',
        ],
    },
};
